// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Ref } from "semantic-ui-react";
import { ApplicationMenuItem } from "../../../components/ApplicationMenu";
import { ApplicationWindow } from "../../../components/ApplicationWindow";
import { DeleteAction, OpenAction, ReorderAction } from "./FavoriteAction";
import { FeatureDataPrefetch } from "../../Feature/components/FeatureDataPrefetch";
import { jsx as _jsx } from "react/jsx-runtime";
export const FavoriteMenuItem = props => {
  const {
    identifiant,
    libelle,
    adresse
  } = props;
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isSorting,
    active
  } = useSortable({
    id: identifiant
  });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    ...(active?.id !== identifiant && isSorting && {
      pointerEvents: "none"
    })
  };
  return /*#__PURE__*/_jsx(ApplicationWindow, {
    path: adresse,
    "data-sentry-element": "ApplicationWindow",
    "data-sentry-component": "FavoriteMenuItem",
    "data-sentry-source-file": "FavoriteMenuItem.tsx",
    children: ({
      onOpen
    }) => /*#__PURE__*/_jsx(FeatureDataPrefetch, {
      path: adresse,
      children: /*#__PURE__*/_jsx(Ref, {
        innerRef: setNodeRef,
        children: /*#__PURE__*/_jsx(ApplicationMenuItem, {
          content: libelle,
          actions: [!isSorting && /*#__PURE__*/_jsx(OpenAction, {
            onClick: onOpen
          }, "open"), !isSorting && /*#__PURE__*/_jsx(DeleteAction, {
            identifiant: identifiant
          }, "delete"),
          /*#__PURE__*/
          // eslint-disable-next-line react/jsx-props-no-spreading
          _jsx(ReorderAction, {
            ...listeners
          }, "reorder")].filter(Boolean),
          path: adresse,
          style: style,
          offset: 1,
          direction: "row",
          popup: !isSorting,
          link: !isSorting,
          sorting: isSorting
          // eslint-disable-next-line react/jsx-props-no-spreading
          ,
          ...attributes
        })
      })
    })
  });
};